module.exports = __webpack_public_path__ + "static/media/perimeter.bbd8bfe2.PNG";